import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUsers = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 24,
	viewBox: "0 0 20 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 22.1667C20 22.7496 19.5025 23.2222 18.8889 23.2222C18.2752 23.2222 17.7778 22.7496 17.7778 22.1667C17.7778 18.0859 14.2955 14.7778 10 14.7778C5.70445 14.7778 2.22222 18.0859 2.22222 22.1667C2.22222 22.7496 1.72476 23.2222 1.11111 23.2222C0.497461 23.2222 0 22.7496 0 22.1667C0 16.92 4.47715 12.6667 10 12.6667C15.5228 12.6667 20 16.92 20 22.1667ZM10 11.6111C6.62493 11.6111 3.88889 9.01188 3.88889 5.80556C3.88889 2.59924 6.62493 0 10 0C13.3751 0 16.1111 2.59924 16.1111 5.80556C16.1111 9.01188 13.3751 11.6111 10 11.6111ZM10 9.5C12.1478 9.5 13.8889 7.84594 13.8889 5.80556C13.8889 3.76517 12.1478 2.11111 10 2.11111C7.85223 2.11111 6.11111 3.76517 6.11111 5.80556C6.11111 7.84594 7.85223 9.5 10 9.5Z",
		stroke: "none"
	})
});
export default SvgUsers;
